<template>
    <div class="cookie-banner grid grid__base" v-if="!cookieAck">
        <div class="cookie-banner--row  grid--row">
            <div class="cookie-banner--text-col grid--col">
                <p class="u-reset cookie-banner--description">
                    <slot>{{ message }}</slot>&nbsp;
                    <a class="u-reset cookie-banner--privacy-link link link__base link__no-underline"
                            :href="settingsUrl">
                        {{ privacyLinkLabel }}
                    </a>
                </p>
            </div>

            <div class="cookie-banner--submit-col grid--col">
                <slot name="form"/>

                <button class="cookie-banner--submit btn btn__even-smaller btn__has-grid btn__primary-green"
                        @click="onConfirm">
                    {{ buttonLabel }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import FormFieldCheckbox from 'framework/global-components/dyn/form/form-field-checkbox/form-field-checkbox';
    import { readCookie, writeCookie } from 'util/dom/cookie';
    import { mapActions, mapState } from 'vuex';

    export default {
        components: { FormFieldCheckbox },
        props: {
            cookieName: {
                type: String,
                required: true,
            },

            settingsUrl: {
                type: String,
                required: true,
            },

            buttonLabel: {
                type: String,
                required: true,
            },

            settingsLabel: {
                type: String,
                default: null,
            },

            privacyLinkLabel: {
                type: String,
                default: null,
            },

            message: {
                type: String,
                required: true,
            },

            actionUrl: {
                type: String,
                required: true,
            },
        },

        computed: {
            ...mapState('cookie', ['cookieAck']),
        },

        methods: {
            ...mapActions('cookie', ['setAllowedGroups', 'setCookieAck']),
            onConfirm() {
                this.setCookieAck({ ack: true });
                document.querySelector('html').classList.remove('cookie-not-accepted');
                writeCookie({
                    key: this.cookieName,
                    value: true,
                    path: '/',
                });
            },
        },

        mounted() {
            const cookieValue = readCookie(this.cookieName);
            this.setCookieAck({ ack: !!cookieValue });

            if (!cookieValue) {
                document.querySelector('html').classList.add('cookie-not-accepted');
            }
        },
    };
</script>
